import { APIURL } from './components/Utility/APIBase'
import axios, { AxiosInstance } from 'axios'
import router from '@/router'
import AuthService from './services/AuthService'

const apiClient: AxiosInstance = axios.create({
  baseURL: APIURL,
  headers: {
    'Content-type': 'application/json; charset=utf-8'
  }
})

// apiClient.interceptors.request.use(function (config) {
//   const token = localStorage.getItem('apitoken')
//   config.headers.Authorization = token ? `Bearer ${token}` : ''
//   return config
// })

apiClient.interceptors.request.use(
  async (config) => {
    // Wait until token is available
    const token = await waitForToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

function waitForToken (timeout = 5000): Promise<string | null> {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('apitoken')
    if (token) return resolve(token)

    const interval = setInterval(() => {
      const t = localStorage.getItem('apitoken')
      if (t) {
        clearInterval(interval)
        resolve(t)
      }
    }, 50)

    setTimeout(() => {
      clearInterval(interval)
      resolve(null)
    }, timeout)
  })
}

apiClient.interceptors.response.use(function (response) {
  if (response.data && response.data.data) {
    response.data = response.data.data // Replace response.data with response.data.data
  }
  return response
}, async function (error) {
  const errorDetails = formatAxiosError(error)
  sendErrorNotification(errorDetails)
  if (error.response !== undefined) {
    const errorCheckType = false // true = check only for invalid token error message, false = check by performing an API count request to a specific endpoint.
    const loggedInStatus = localStorage.getItem('status')
    const loginType = localStorage.getItem('logintype')
    const userdata = localStorage.getItem('user')
    const token = localStorage.getItem('apitoken')
    let doRouterPushFlag = true

    if (error.response && error.response.status === 401) {
      // store.dispatch('logout')
      // router.push('/login')
      // Check for whether user is a guest or not and try to do the appropriate thing concerning the site login / logoff and redirection.
      if (loggedInStatus !== undefined && loggedInStatus !== null && loggedInStatus === true.toString() && loginType !== undefined && loginType !== null && loginType === false.toString() && userdata !== undefined && userdata !== null && userdata.startsWith('{"id":1,')) {
        if (errorCheckType && error.response.data && error.response.data.message.toString().toLowerCase().includes('invalid token')) {
          AuthService.logout(true)
          doRouterPushFlag = false
        } else {
          try {
            // The polled API endpoint must not be accessible for the public user role when doing count GET requests, but must be accessible for the authenticated user role.
            const response = await axios.get(APIURL + '/ekstern-services/count', { headers: { 'Content-type': 'application/json; charset=utf-8', Authorization: `Bearer ${token}` } })
          } catch (error2) {
            // let message
            if (axios.isAxiosError(error2) && error2.response) {
              // message = error.response.data.message
              if (error2.response.status === 401) {
                AuthService.logout(true)
                doRouterPushFlag = false
              }
            }
          }
        }

        if (doRouterPushFlag) {
          console.log('doRouterPushFlag reload occurs from here >>')
          if (router.currentRoute.value.path !== '/medlemsportal/login') {
            router.push({ path: '/medlemsportal/login' })
          }
        }
      } else if (loggedInStatus !== undefined && loggedInStatus !== null && loggedInStatus === true.toString()) {
        AuthService.logout()
        console.log(' reload occurs from here >>')
        if (router.currentRoute.value.path !== '/medlemsportal/login') {
          router.push({ path: '/medlemsportal/login' })
        }
        // window.location.reload()
      } else {
        AuthService.logout()
      }
    }
  }

  return Promise.reject(error)
})

export default apiClient

// Function to send error notifications
function sendErrorNotification (curlCommand: any) {
  fetch((process.env.VUE_APP_API_URL || 'https://billards.app.demo4work.com/api') + 'error-notifies', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ error: curlCommand, requestUrl: curlCommand.requestUrl })
  })
}

// Function to generate a cURL command from axios request config
const formatAxiosError = (error: any) => {
  return {
    requestUrl: error.config?.url || null,
    requestMethod: error.config?.method || null,
    requestPayload: error.config?.data ? JSON.parse(error.config.data) : null,
    responseStatus: error.response?.status || null,
    responseMessage: error.response?.statusText || null,
    responseData: error.response?.data || null,
    errorMessage: error.message || 'Unknown error occurred'
  }
}
